import type { ComponentProps, ReactNode } from 'react'
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { typographyVariants } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

export function OgsmDialogContent({
  className,
  ...props
}: ComponentProps<typeof DialogContent>) {
  return (
    <DialogContent
      className={cn(
        'flex max-h-[90dvh] max-w-135 flex-col gap-0 overflow-hidden p-0',
        className
      )}
      {...props}
    />
  )
}

export interface OgsmDialogHeaderProps {
  title: ReactNode
  /** Lines under the title (a subtitle or a `DialogDescription`). */
  children?: ReactNode
}

export function OgsmDialogHeader({ title, children }: OgsmDialogHeaderProps) {
  return (
    <DialogHeader className="gap-1.5 border-b border-primary/10 px-5 py-4 pr-12 text-left">
      <DialogTitle className={typographyVariants({ variant: 'h3' })}>
        {title}
      </DialogTitle>
      {children}
    </DialogHeader>
  )
}

export function FormBody({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-0 flex-col gap-4 overflow-y-auto px-5 py-5">
      {children}
    </div>
  )
}

export function FormFooter({ children }: { children: ReactNode }) {
  return (
    <div className="flex justify-end gap-2 border-t border-primary/10 bg-muted px-5 py-4">
      {children}
    </div>
  )
}
